import { PlugIcon, PluggedIcon } from './PlugIcon';
import styles from './ConnectButton.module.css';

interface ConnectButtonProps {
  onClick: () => void;
  label?: string;
  /**
   * Ключ уже привязан к устройству: вилка воткнута в розетку, контур зелёный
   * и пульсирует, подпись «Отвязать устройство», onClick — отвязка.
   */
  connected?: boolean;
  /** Идёт запрос (отвязка): кнопка заблокирована, подпись «Отвязываем…» */
  loading?: boolean;
}

/**
 * «Подключить» / «Отвязать устройство»: крупный значок вилки, под ним кнопка.
 * Это один <button>, поэтому и значок, и подпись кликаются одинаково.
 */
export function ConnectButton({ onClick, label, connected = false, loading = false }: ConnectButtonProps) {
  const text = label ?? (connected ? (loading ? 'Отвязываем…' : 'Отвязать устройство') : 'Подключить');
  return (
    <button
      type="button"
      className={`${styles.connect} ${connected ? styles.connected : ''}`}
      onClick={onClick}
      disabled={loading}
      aria-busy={loading || undefined}
    >
      <span className={styles.icon}>
        {connected ? <PluggedIcon size={40} /> : <PlugIcon size={40} />}
      </span>
      <span className={styles.label}>{text}</span>
    </button>
  );
}
